import { render, staticRenderFns } from "./loanreqView.vue?vue&type=template&id=231447ea&scoped=true&"
import script from "./loanreqView.vue?vue&type=script&lang=js&"
export * from "./loanreqView.vue?vue&type=script&lang=js&"
import style0 from "./loanreqView.vue?vue&type=style&index=0&id=231447ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231447ea",
  null
  
)

export default component.exports